// The name a forecast is shown under in the Forecast Manager.
//
// The PREPROCESSED question — `contract.question`, the same text the QUESTION section
// shows — not what the user typed in chat. The typed text is only the fallback, for a
// row whose preprocessing has not produced a question yet (or never did).

/**
 * @param {object|null|undefined} f a forecast row
 * @returns {string} the preprocessed question, else the typed one, else the contract
 *   title, else "Unnamed"
 */
export function forecastDisplayName(f) {
  // `contractQuestion` is the same text carried separately, so a lean-loaded row (no
  // contract until its detail backfills) is named correctly from first paint.
  return (
    f?.contract?.question || f?.contractQuestion || f?.question || f?.contract?.title || "Unnamed"
  );
}
